const EMAIL_FORMAT_REGEX = /^[A-Z0-9.!#$%&'*+-\/=?^_`{|}]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i;


export function emailFormatValidator() {
    return (email: string) => !!email && EMAIL_FORMAT_REGEX.test(email.trim());
}
